import { FormGroup, Grid, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { Hoster } from '../../interfaces/Hoster';
import BaseModule, { BaseModuleProps } from './module/baseModule';
import VoipModule from './module/VoipModule';

interface OfferProps {
  hoster: Partial<Hoster>;
  onChange: (key: keyof Hoster['subscriptionStatus'], value: boolean) => void;
  setHoster: React.Dispatch<React.SetStateAction<Partial<Hoster>>>;
}

const Offer: React.FC<OfferProps> = (props) => {
  const moduleProps: Omit<BaseModuleProps, 'name' | 'label'> = useMemo(
    () => ({
      hoster: props.hoster,
      onChange: props.onChange as any,
      setHoster: props.setHoster,
    }),
    [props.hoster, props.onChange, props.setHoster],
  );

  return (
    <FormGroup sx={{ m: 1 }}>
      <Grid container spacing={2} sx={{ flexDirection: 'column' }}>
        <Grid item>
          <Typography variant="body1" fontWeight={'bold'}>
            Solutions
          </Typography>
          <BaseModule
            {...moduleProps}
            name="isPoliceRecordSubscribed"
            label="Check-in dématérialisé"
            onChange={(key, value) => {
              props.setHoster({
                ...props.hoster,
                subscriptionStatus: {
                  ...props.hoster.subscriptionStatus!,
                  isPoliceRecordSubscribed: value,
                  isCRMCustomerPathSubscribed:
                    value ||
                    props.hoster.subscriptionStatus?.isSatisfactionSurveysSubscribed ||
                    false,
                },
              });
            }}
          />
          <BaseModule {...moduleProps} name="isGuestAppSubscribed" label="Room directory" />
          <VoipModule {...moduleProps} />
          <BaseModule
            {...moduleProps}
            name="isSatisfactionSurveysSubscribed"
            label="Satisfaction client"
            onChange={(key, value) => {
              props.setHoster({
                ...props.hoster,
                subscriptionStatus: {
                  ...props.hoster.subscriptionStatus!,
                  isSatisfactionSurveysSubscribed: value,
                  isCRMCustomerPathSubscribed:
                    value || props.hoster.subscriptionStatus?.isPoliceRecordSubscribed || false,
                },
              });
            }}
          />
          <BaseModule {...moduleProps} name="isEreputationSubscribed" label="E-réputation" />
          <BaseModule
            {...moduleProps}
            name="isCRMCustomerEngagementSubscribed"
            label="Campagne marketing"
          />
        </Grid>
        <Grid item>
          <Typography variant="body1" fontWeight={'bold'}>
            Options
          </Typography>
          <BaseModule
            {...moduleProps}
            name="isAdditionalSellsSubscribed"
            label="Ventes additionnelles"
          />
          <BaseModule
            {...moduleProps}
            name="isSmsCRMCustomerPathSubscribed"
            label="SMS"
            onChange={(key, value) => {
              props.setHoster({
                ...props.hoster,
                subscriptionStatus: {
                  ...props.hoster.subscriptionStatus!,
                  isSmsCRMCustomerPathSubscribed: value,
                  isSmsCRMCustomerEngagementSubscribed: value,
                },
              });
            }}
          />
        </Grid>
      </Grid>
    </FormGroup>
  );
};

export default Offer;
